import { DialogUtility } from '@syncfusion/ej2-react-popups';
import { DropDownButtonComponent } from '@syncfusion/ej2-react-splitbuttons';
import { Privileges } from '../../../util/PrivilegeConstants';
import { updateScheduleStatus } from './ScheduleCURD';
import { useDispatch } from 'react-redux';
import { rootAction } from '../../../redux/reducer/rootReducer';
import { debounce } from 'lodash';
import { ScheduleStatus } from '../../../util/CalendarUtil';

const EditorFooterTemplate = ({ args, privileges, selectedClub, scheduleRef, setIsRefresh }) => {
    const dispatch = useDispatch()
    const debouncedRefresh = debounce(() => {
        setIsRefresh(true);
        if (selectedClub.isPlanRequired) {
            dispatch(rootAction.setIsUpdateTotalSchedule(true));
        }
    }, 420);

    const handleUpdateScheduleStatus = async (status) => { 
        try {
            const rule = document.querySelector('#coach-recurrence-editor')?.ej2_instances[0]?.value;
            const obj = {
                id: args.Id,
                clubId: selectedClub.clubId,
                recurrenceId: rule ? args.RecurrenceID : null,
                status: status
            }
            await updateScheduleStatus(obj);
            scheduleRef.current.closeEditor();
            dialogObj.hide();
            debouncedRefresh();
        } catch (e) {
            scheduleRef.current.closeEditor();
            console.error(e);

        }
    }
    let items = [
        {
            text: 'Delete',
        },
        {
            text: 'Cancel',
        }
    ];

    let dialogObj;

    function onSelect(args) {
        if (args.item.text === 'Delete') {
            dialogObj = DialogUtility.confirm({
                title: 'Delete Schedule',
                content: 'Are you sure you want to permanently delete this schedule?',
                width: '300px',
                position: { X: 'center', Y: 'center' },
                animationSettings: { effect: 'Zoom' },
                cssClass: 'fixthis',
                okButton: {click: ()=>handleUpdateScheduleStatus(ScheduleStatus.DELETE)},
                cancelButton: {
                    click: () => {
                        dialogObj.hide();
                    }
                }
            });
        }
        if (args.item.text === 'Cancel') {
            dialogObj = DialogUtility.confirm({
                title: 'Cancel Schedule',
                content: 'Are you sure you want to cancel this schedule?',
                width: '300px',
                position: { X: 'center', Y: 'center' },
                animationSettings: { effect: 'Zoom' },
                cssClass: 'fixthis',
                okButton: {click: ()=>handleUpdateScheduleStatus(ScheduleStatus.CANCELED)},
                cancelButton: {
                    click: () => {
                        dialogObj.hide();
                    }
                }
            });
        }
    }

    return (
        <div id="event-footer" style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div id="left-button">
                {(args?.Id && privileges?.RESERVATION?.includes(Privileges.DELETE)) &&
                    <DropDownButtonComponent id="element" items={items} select={onSelect}>
                        More Actions</DropDownButtonComponent>
                }
            </div>
            <div id="right-button">
                {(!args?.Id && privileges?.RESERVATION?.includes(Privileges.CREATE) || (args?.Id && privileges?.RESERVATION?.includes(Privileges.MODIFY))) &&
                    <button id="Save" className="e-control e-btn e-primary" data-ripple="true" >
                        Save
                    </button>}
                <button id="Cancel" className="e-control e-btn e-secondary" data-ripple="true">
                    Cancel
                </button>
            </div>
        </div>
    );
}

export default EditorFooterTemplate